// client/src/components/pages/DriverPWA/LocationTracker.js
import { useEffect, useRef } from 'react';

/**
 * Background location tracker using navigator.geolocation.watchPosition
 * Invisible component — just handles GPS and calls onLocationUpdate
 */
export default function LocationTracker({ active, onLocationUpdate }) {
  const watchIdRef = useRef(null);

  useEffect(() => {
    if (!active) {
      if (watchIdRef.current !== null) {
        navigator.geolocation.clearWatch(watchIdRef.current);
        watchIdRef.current = null;
      }
      return;
    }

    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by this browser');
      return;
    }

    watchIdRef.current = navigator.geolocation.watchPosition(
      (position) => {
        onLocationUpdate({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          speed: position.coords.speed ? position.coords.speed * 3.6 : null, // m/s to km/h
          heading: position.coords.heading,
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          timestamp: position.timestamp,
        });
      },
      (error) => {
        console.error('Geolocation error:', error.message);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 10000, // Accept cached position up to 10s old
        timeout: 15000,
      }
    );

    return () => {
      if (watchIdRef.current !== null) {
        navigator.geolocation.clearWatch(watchIdRef.current);
        watchIdRef.current = null;
      }
    };
  }, [active, onLocationUpdate]);

  return null;
}
